<template>
  <v-panel>
    <v-form ref="form" v-model="valid" >
      <div class="divider">
        <span>
          <b>Dados das Receitas - Bovinos para Outros Destinos</b>
        </span>
      </div>
      <v-flex md11>
            <div class="divider2 text-xs-center">
              <span class="headline">
                <b>Fêmeas + 36 meses</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify-center row wrap>
              <v-flex xs3 sm3 md3>
                <div class="text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="femeas36ValorUnitarioRSCabeca"
                  v-model="formulario.femeas36ValorUnitarioRSCabeca"
                  type="number"
                  background-color="white"
                  label="R$/cab"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs3 sm3 md3>
                <div class="text-xs-center">
                  <span>
                    <b>Peso médio</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="femeas36PesoMedioKGVivo1"
                  v-model="formulario.femeas36PesoMedioKGVivo1"
                  type="number"
                  background-color="white"
                  label="kg vivo"
                  box                      
                ></v-text-field>
              </v-flex>
              <v-flex xs3 sm3 md3>
                <div class="text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="femeas36cabeca1"
                  v-model="formulario.femeas36cabeca1"
                  type="number"
                  background-color="white"
                  label="Cabeças"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
            <div class="divider2 text-xs-center">
              <span class="headline">
                <b>Fêmeas 24-36 meses</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs3 sm3 md3>
                <div class="text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="femeas2436ValorUnitarioRSCabeca"
                  v-model="formulario.femeas2436ValorUnitarioRSCabeca"
                  type="number"
                  background-color="white"
                  label="R$/cab"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs3 sm3 md3>
                <div class="text-xs-center">
                  <span>
                    <b>Peso médio</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="femeas2436PesoMedioKGVivo1"
                  v-model="formulario.femeas2436PesoMedioKGVivo1"
                  type="number"
                  background-color="white"
                  label="kg vivo"
                  box                      
                ></v-text-field>
              </v-flex>
              <v-flex xs3 sm3 md3>
                <div class="text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="femeas2436cabeca1"
                  v-model="formulario.femeas2436cabeca1"
                  type="number"
                  background-color="white"
                  label="Cabeças"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Fêmeas 12-24 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas1224ValorUnitarioRSCabeca"
              v-model="formulario.femeas1224ValorUnitarioRSCabeca"
              type="number"
              background-color="white"
              label="R$/cab"
              box
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas1224PesoMedioKGVivo1"
              v-model="formulario.femeas1224PesoMedioKGVivo1"
              type="number"
              background-color="white"
              label="kg vivo"
              box                      
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas1224cabeca1"
              v-model="formulario.femeas1224cabeca1"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>
    
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Fêmeas 0-12 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas012ValorUnitarioRSCabeca"
              v-model="formulario.femeas012ValorUnitarioRSCabeca"
              type="number"
              background-color="white"
              label="R$/cab"
              box
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas012PesoMedioKGVivo1"
              v-model="formulario.femeas012PesoMedioKGVivo1"
              type="number"
              background-color="white"
              label="kg vivo"
              box                      
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas012cabeca1"
              v-model="formulario.femeas012cabeca1"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>
      
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Machos 0-12 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos012ValorUnitarioRSCabeca"
              v-model="formulario.machos012ValorUnitarioRSCabeca"
              type="number"
              background-color="white"
              label="R$/cab"
              box
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos012PesoMedioKGVivo1"
              v-model="formulario.machos012PesoMedioKGVivo1"
              type="number"
              background-color="white"
              label="kg vivo"
              box                      
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos012cabeca1"
              v-model="formulario.machos012cabeca1"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Machos 12-24 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos1224ValorUnitarioRSCabeca"
              v-model="formulario.machos1224ValorUnitarioRSCabeca"
              type="number"
              background-color="white"
              label="R$/cab"
              box
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos1224PesoMedioKGVivo1"
              v-model="formulario.machos1224PesoMedioKGVivo1"
              type="number"
              background-color="white"
              label="kg vivo"
              box                      
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos1224cabeca1"
              v-model="formulario.machos1224cabeca1"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Machos 24-36 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos2436ValorUnitarioRSCabeca"
              v-model="formulario.machos2436ValorUnitarioRSCabeca"
              type="number"
              background-color="white"
              label="R$/cab"
              box
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos2436PesoMedioKGVivo1"
              v-model="formulario.machos2436PesoMedioKGVivo1"
              type="number"
              background-color="white"
              label="kg vivo"
              box                      
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos2436cabeca1"
              v-model="formulario.machos2436cabeca1"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Machos + 36 meses (Inclusive tourunos)</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos36ValorUnitarioRSCabeca"
              v-model="formulario.machos36ValorUnitarioRSCabeca"
              type="number"
              background-color="white"
              label="R$/cab"
              box
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos36PesoMedioKGVivo1"
              v-model="formulario.machos36PesoMedioKGVivo1"
              type="number"
              background-color="white"
              label="kg vivo"
              box                      
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos36cabeca1"
              v-model="formulario.machos36cabeca1"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Touros</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="touroValorUnitarioRSCabeca"
              v-model="formulario.touroValorUnitarioRSCabeca"
              type="number"
              background-color="white"
              label="R$/cab"
              box
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="touroPesoMedioKGVivo1"
              v-model="formulario.touroPesoMedioKGVivo1"
              type="number"
              background-color="white"
              label="kg vivo"
              box                      
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm3 md3>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="tourocabeca1"
              v-model="formulario.tourocabeca1"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
          {{form}}
        </v-layout>
      </v-flex>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import ReceitaAnual from "../../class/ReceitaAnual.js";
export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new ReceitaAnual(),
    panel: [],
    lazy: true,
    valid: false,
    simulation: ''
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new ReceitaAnual(dado.bovinoOutro);
      });
    }
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>